/* eslint-disable */
/* istanbul ignore file */
import React, { type Dispatch, useState } from 'react'
import { Grid, CardContent, IconButton, CircularProgress } from '@mui/material'
import DefaultImage from '../../../assets/No-Image.png'
import LanguageStrings from '../../../i18n/locales'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { connect, type ConnectedProps, useSelector } from 'react-redux'
import { assetDeleteCampaign } from '../../asset-managament/redux/actionCreator'
import { useNavigate } from 'react-router-dom'
import GenericModal from '../../../components/Modal'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { APIConfiguration } from '../../../utils/apiConfiguration'
import { type RootState } from '../../../store'
import moment from 'moment-timezone'
import { Tooltip } from '@mui/material'
import { useAuth } from 'react-oidc-context'

const AssetInformationStrings = LanguageStrings().GatewayManagementCollectionStrings.AssetInformationComponent
const httpStatus = APIConfiguration

const AssetInformation = (props: PropsFromRedux & { parentSiteId: any, assetInfo: any, imageBinaryData: any}): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const auth = useAuth()
  const navigate = useNavigate()
  const [selectedAssetId, setSelectedAssetId] = useState('')
  const [confirmDeletePopup, setConfirmDeletePopup] = useState(false)
  const [showDeleteStatus, setShowDeleteStatus] = useState(false)
  const assetDeleteStatus = useSelector(
    (state: RootState) => state.assetDeleteState
  )
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const handleEdit = (): void => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    navigate(`/edit-asset/${props.assetInfo.assetInfo.id}`, {
      state: {
        assetId: props.assetInfo.assetInfo.id,
        assetName: props.assetInfo.assetInfo.name,
        assetDescription: props.assetInfo.assetInfo.description,
        gatewayId: props.assetInfo.assetInfo.gateway_id,
        gatewayName: props.assetInfo.assetInfo.gateway_name,
        parentAssetId: props.parentSiteId
      }
    })
  }

  const handleDelete = (): void => {
    setSelectedAssetId(props.assetInfo.assetInfo.id)
    setConfirmDeletePopup(true)
    setAnchorEl(null)
  }

  const handleDeleteCampaign = (): void => {
    setConfirmDeletePopup(false)
    setShowDeleteStatus(true)
    props.assetDeleteCampaign(selectedAssetId, auth.user?.profile.sub ?? '')
  }

  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 40) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 40)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : '-'}</span>
  }

  const handleDeleteCampaignWithFailure = (): JSX.Element => {
    /* istanbul ignore next */
    if (assetDeleteStatus.httpStatus === httpStatus.SUCCESS_HTTP_STATUS) {
      return (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={AssetInformationStrings.successfullyDeleted}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            navigate(`/thermal-asset-list/${props.parentSiteId}`) // Redirect after closing the modal
          }}
          onClose={() => {
            setShowDeleteStatus(false)
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            navigate(`/thermal-asset-list/${props.parentSiteId}`) // Redirect after closing the modal
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
              {AssetInformationStrings.FullMsgAssetDeletedSuccessfully}
          </p>
        </GenericModal>
      )
    } else if (assetDeleteStatus.isLoading) {
      return (
        <GenericModal title={'Loading...'}>
          <div className="CircularprogressAmi">
            <CircularProgress />
          </div>
        </GenericModal>
      )
    } else if (assetDeleteStatus.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {assetDeleteStatus.error} </p>
        </GenericModal>
      )
    } else if (assetDeleteStatus.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="Unauthorized" />
        </div>
      )
    } else if (assetDeleteStatus.httpStatus === httpStatus.ACCESS_FORBIDDEN_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="accessForbidden" />
        </div>
      )
    } else {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {assetDeleteStatus.error} </p>
        </GenericModal>
      )
    }
  }

  return (
      <>
        <CardContent style={{ padding: '0px', position: 'relative' }}>
          <Grid style={{display : 'flex'}}>
            <div>
              <div style={{ padding: '10px', backgroundColor: '#303030', height: 'fit-content', borderRadius: '10px', width: 'fit-content' }}>
                <img
                  src={props.imageBinaryData && props.imageBinaryData.binaryData
                    ? `data:image/jpeg;base64,${props.imageBinaryData.binaryData}`
                    : DefaultImage}
                  alt="Preview" style={{ width: '136px', height: '136px' }}
                />
              </div>
            </div>
            <div style={{display: 'contents'}} >
            <Grid container>
              <Grid container xs={12} sm={11} style={{ paddingLeft: '20px' }}>
                <Grid item xs={12} sm={12}>
                  <Grid>
                    <span style={{ fontSize: 'small', fontWeight: '600' }}>
                      {AssetInformationStrings.AssetInformation}
                    </span>
                  </Grid>
                </Grid>
                <Grid container justifyContent='space-between'>
                  <Grid item xs={12} sm={3}>
                    <Grid>{AssetInformationStrings.Name}</Grid>
                    <Grid>{formatTextWithTooltip(props?.assetInfo?.assetInfo?.name)}</Grid>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Grid>{AssetInformationStrings.CreatedOn}</Grid>
                    <Grid>
                      {props?.assetInfo?.assetInfo !== null && props?.assetInfo?.assetInfo?.install_date !== null && props?.assetInfo?.assetInfo?.install_date !== '' ? moment.utc(props?.assetInfo?.assetInfo?.install_date).tz(userTimezone).format('hh:mm A, MMM DD YYYY') : ''}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Grid>{AssetInformationStrings.Description}</Grid>
                    <Grid>{formatTextWithTooltip(props?.assetInfo?.assetInfo?.description)}</Grid>
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginLeft: 'auto', position: 'relative' }}>
                    <IconButton
                      aria-haspopup="true"
                      aria-controls={open ? 'fade-menu' : undefined}
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                      sx={{ padding: '0px !important', position: 'absolute', top: 0, right: 0 }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="fade-menu"
                      MenuListProps={{ 'aria-labelledby': 'fade-button' }}
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                    >
                      <MenuItem onClick={handleEdit} style={{ color: '#64c3ff', textDecoration: 'none' }}>Edit</MenuItem>
                      <MenuItem onClick={handleDelete} style={{ color: '#64c3ff', textDecoration: 'none' }}>Delete</MenuItem>
                    </Menu>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            </div>
          </Grid>
        </CardContent>
        {confirmDeletePopup && (
          <GenericModal
            width="600px"
            height="260px"
            buttonTypeNegative="hollow"
            title={'Delete Asset'}
            LabelPositive="Confirm"
            LabelNegative="Cancel"
            onClickPositive={handleDeleteCampaign}
            onClose={() => { setConfirmDeletePopup(false) }}
            onClickNegative={() => { setConfirmDeletePopup(false) }}
          >
            <p style={{ paddingTop: '1.2em' }}>
              {AssetInformationStrings.DeleteConfirmation}<br/><br/>
              {AssetInformationStrings.DeleteConfirmationWarning}
            </p>
          </GenericModal>
        )}
        {
            /* istanbul ignore next */
            showDeleteStatus && handleDeleteCampaignWithFailure()
        }
    </>
  )
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  assetDeleteCampaign: (selectedAssetId: string, subId: string) => { dispatch(assetDeleteCampaign(selectedAssetId, subId)) }
})

const connector = connect(null, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AssetInformation)
